import { zLayer } from "@sellar-io/components";
import type { ReactNode } from "react";
import { Outlet } from "react-router";
import { useSellarCurrentBusiness } from "../../hooks/useSellarCurrentBusiness.shared";
import { retailerContentClasses } from "./retailerLayoutClasses";
import { NavigationOverlayProvider } from "./overlays/NavigationOverlayProvider";

export const RetailerLayout = ({ header }: { header?: ReactNode }) => {
  const { business } = useSellarCurrentBusiness();
  return (
    <NavigationOverlayProvider businessId={business?.id}>
      <div className="flex min-h-full min-w-0 flex-col">
        {header && (
          <header
            className={`sticky top-[var(--refresh-pwa-banner-height)] shrink-0 bg-white min-[641px]:top-0 ${zLayer.navigationBar}`}
          >
            {header}
          </header>
        )}
        <main className={`${retailerContentClasses} min-w-0 flex-1`}>
          <Outlet />
        </main>
      </div>
    </NavigationOverlayProvider>
  );
};
